import { device } from 'src/styles/breakpoints'
import { grayscale } from 'src/styles/colors'
import styled from 'styled-components'

export const Section = styled.section`
  h2 {
    font-family: 'Citrina', Helvetica, sans-serif;
    font-size: 28px;
    line-height: 34px;
    font-weight: 700;
    margin-bottom: 20px;

    @media ${device.tablet} {
      font-size: 48px;
      line-height: 52px;
    }
  }

  p {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: ${grayscale[400]};
    margin-bottom: 32px;

    @media ${device.desktopXXL} {
      font-size: 18px;
      line-height: 22px;
    }
  }
`
